<script>
  export default {
    name: 'CardDepartment',
    props: [
      'bottomShadow',
      'cardColor',
      'color',
      'primaryTextColor',
      'image',
      'buttonColor',
      'buttonTextColor',
      'imagePosition',
      'titleText',
      'bodyText',
      'icon',
      'buttonText',
      'buttonTo'
    ],
    methods: {},
    computed: {},
    created() {}
  }
</script>
<template>
  <!-- <v-card hover :color="cardColor" class="ma-1" style="height: 100px; width: 100px; "> -->
  <v-card hover :color="cardColor" :to="{ name: buttonTo }" class="card pa-0 mt-0">
    <v-card-title :class="`${color}--text`" class="card-title font-weight-black text-h5">
      <v-icon left :color="color">
        {{ icon }}
      </v-icon>
      {{ buttonText }}
    </v-card-title>
    <v-card-text :class="`${primaryTextColor}--text`" class="card-text pa-0">
      <v-img eager :src="image" min-height="300px" height="100%" max-height="400px" :position="imagePosition || 'center center'" width="100%" class="image"></v-img>
    </v-card-text>
    <!-- <v-card-actions :class="`d-flex align-center justify-center card-action bottom-shadow-${bottomShadow} pa-4`">
      <v-btn block outlined rounded :color="buttonColor" class="btn-card-action font-weight-bold" :to="{ name: buttonTo }">
        <v-icon left>{{ buttonIcon }}</v-icon>
        {{ buttonText }}
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>
<style scoped>
  .card {
    overflow: hidden;
    position: relative;
  }
  .card:hover .image {
    transition: transform 1.5s ease-in-out;
    transform: scale(1.25);
  }

  .card-title {
    position: relative;
    z-index: 2;
  }

  .card-text {
    overflow: hidden;
  }

  .image {
    position: relative;
    transition: transform 1s ease-in-out;
    transform: scale(1);
    z-index: 1;
  }

  .card-action {
    position: absolute;
    bottom: 0px;
    width: 100%;
    /* background: linear-gradient(to top, rgb(0, 0, 0), rgba(0, 0, 0, 0)); */
  }

  .bottom-shadow-dark {
    background: linear-gradient(to top, rgb(0, 0, 0), rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
  }

  .bottom-shadow-light {
    background: linear-gradient(to top, rgb(255, 240, 240, 1), rgba(242, 242, 242, 0));
  }

  .btn-card-action {
    /* max-width: 90% !important; */
  }
</style>
